import { ReactComponent as DotsIcon } from 'assets/icons/dots.svg'
import { useState } from 'react'

import { Check, MarkAllItem, OptionItem, Popover, TriggerButton } from './styled'

type Props = {
  value: boolean | undefined
  onChange: (value: boolean | undefined) => void
  onMarkAllAsRead?: () => void
}

const OPTIONS: { label: string; value: boolean | undefined }[] = [
  { label: 'All', value: undefined },
  { label: 'Unplayed', value: false },
  { label: 'Played', value: true },
]

function PlayedFilterDropdown({ value, onChange, onMarkAllAsRead }: Props) {
  const [open, setOpen] = useState(false)

  const onSelect = (v: boolean | undefined) => {
    onChange(v)
    setOpen(false)
  }

  const onMarkAll = () => {
    setOpen(false)
    onMarkAllAsRead?.()
  }

  return (
    <Popover
      placement="bottomRight"
      trigger="click"
      open={open}
      onOpenChange={setOpen}
      content={
        <div onClick={(e) => e.stopPropagation()}>
          {OPTIONS.map((opt) => (
            <OptionItem key={opt.label} selected={opt.value === value} onClick={() => onSelect(opt.value)}>
              {opt.label}
              {opt.value === value && <Check>✓</Check>}
            </OptionItem>
          ))}
          {onMarkAllAsRead && <MarkAllItem onClick={onMarkAll}>Mark all as read</MarkAllItem>}
        </div>
      }
    >
      <TriggerButton type="button" aria-label="Filter by played status">
        <DotsIcon />
      </TriggerButton>
    </Popover>
  )
}

export default PlayedFilterDropdown
